export default "__VITE_ASSET__DotKCu8D__"